import { ScrollView } from 'react-native';

import { SelectedFile } from '%hooks/usePickedFiles';
import { File as UploadedFile } from '%__generated__/types';
import { File } from './File';

interface Props {
	files: (SelectedFile | UploadedFile)[];
	onRemovePress?: (index: number) => () => void;
}

export const FileList = ({ files, onRemovePress }: Props) => {
	return (
		<ScrollView>
			{files.map((document, fileIndex) => {
				const isSelectedFile = getIsSelectedFile(document);

				return (
					<File
						key={isSelectedFile ? document.uuid : document.id}
						name={(isSelectedFile ? document.file?.name : document.name) || ''}
						url={isSelectedFile ? undefined : document.url}
						onRemove={onRemovePress?.(fileIndex)}
					/>
				);
			})}
		</ScrollView>
	);
};

function getIsSelectedFile(file: SelectedFile | UploadedFile): file is SelectedFile {
	return (file as SelectedFile).file !== undefined;
}
